import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0005 6C10.2563 6 10.5123 6.10681 10.7073 6.32043L16.707 12.8829C17.0977 13.3102 17.0977 14.0023 16.707 14.4296C16.3164 14.8568 15.6837 14.8568 15.293 14.4296L10.0005 8.63867L4.70695 14.4287C4.31635 14.856 3.68356 14.856 3.29296 14.4287C2.90235 14.0015 2.90235 13.3093 3.29296 12.8821L9.29269 6.31958C9.48799 6.10596 9.74423 6 10.0005 6Z",
		fill: "#0D2976"
	})
});
export default SvgChevronUp;
